import { load } from "@nextgisweb/jsrealm/i18n/catalog";
load("layer_preview", {"":{"Toggle basemap":["Переключить подложку"]}})